import React from "react";
import { Header, Footer } from "../";
import "./OuterWrapper.css";

const OuterWrapper = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "100vh",
        minWidth: "100vw",
        maxWidth: "100vw",
      }}
    >
      <Header />
      <div style={{ flex: 1, maxWidth: "100vw" }}>{children}</div>

      <Footer />
    </div>
  );
};

export default OuterWrapper;
